<template>
  <div class="page-tab withdraw-account-v2">
    <ManageBankAccountManageTabDialog :member-info="memberInfo" :target-info="targetInfo" :is-active="isActive" :reset-key="resetKey" />
  </div>
</template>

<script>
import { computed } from 'vue'
import ManageBankAccountManageTabDialog from '../../ManageBankAccountManageTabDialog.vue'

export default {
  name: 'ManageWithdrawAccountTabV2',
  components: { ManageBankAccountManageTabDialog },
  props: {
    resetKey: { type: Number, default: 0 },
    targetInfo: { type: Object, default: () => ({}) },
    isActive: { type: Boolean, default: false },
  },
  setup(props) {
    const memberInfo = computed(() => ({
      username: props.targetInfo?.username || '',
    }))
    return { memberInfo }
  },
}
</script>
